module.exports = __webpack_public_path__ + "img/en_lang_invite.6100c215.svg";